import { render, staticRenderFns } from "./PazienteAssociaProgettoModale.vue?vue&type=template&id=4c11b718&scoped=true"
import script from "./PazienteAssociaProgettoModale.vue?vue&type=script&lang=js"
export * from "./PazienteAssociaProgettoModale.vue?vue&type=script&lang=js"
import style0 from "./PazienteAssociaProgettoModale.vue?vue&type=style&index=0&id=4c11b718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c11b718",
  null
  
)

export default component.exports